import Vue from 'vue';
import '../../vendors/jquery-global.js';
import 'es6-promise/auto';
import VueShave from 'vue-shave';
import $ from 'jquery';
import jQuery from 'jquery';
import 'bootstrap-sass/assets/javascripts/bootstrap';
import 'lazysizes';
import 'jquery-match-height';
import 'owl.carousel';
import '../../vendors/owlcarousel2-a11ylayer.js';
import SitecoreVueBridge from '@refapp/sitecore-vue-bridge';
import ClinicalTest from '../../components/clinical-test/clinical-test.vue';
import ProductDetail from '../../components/product-detail/product-detail.vue';
import VueScrollTo from 'vue-scrollto';
import VuePaginate from 'vue-paginate';
import { highlight } from 'vue-words-highlight';
import CarouselInstaller from '../../components/carousel/index.js';
// Load the CommonJS build, not `vue-youtube` (its ESM file).
// Vite prefers the package's ESM entry, but that file still uses Node's require()
// for youtube-player. Vite then leaves require() in our browser bundle, which
// crashes (`require is not defined`). The .common.js file is treated as CJS, so
// Vite rewrites require() into real imports before shipping the bundle.
import VueYoutube from 'vue-youtube/dist/vue-youtube.common.js';
import checkView from 'vue-check-view';

// Redesign Vue component DI
import homepageblock from '../../components/home-page-block/home-page-block.vue';
import homepageblockright from '../../components/home-page-block-right/home-page-block-right.vue';
import Banner from '../../components/redesign/banner/banner.vue';
import Product from '../../components/redesign/product/product.vue';
import Tab from '../../components/redesign/tab/tab.vue';
import carouselHome from '../../components/carousel-home/carousel-home.vue';
import RatingsAndReviews from '../../components/ratings-and-reviews/ratings-and-reviews.vue';
import ProductShortDetails from '../../components/product-short-details/product-short-details.vue';
import ArticleDetailPage from '../../components/article-detail-page/article-detail-page.vue';
import BlocMixaMag from '../../components/bloc-mixa-mag/bloc-mixa-mag.vue';
import MixaMagLatestArticle from '../../components/mixa-mag-latest-article/mixa-mag-latest-article.vue';
import MixaMagCategory from '../../components/mixa-mag-category/mixa-mag-category.vue';
import PopularItems from '../../components/popular-items/popular-items.vue';
import Faq from '../../components/faq/faq.vue';
import Commitments from '../../components/commitments/commitments.vue';
import Impressum from '../../components/impressum/impressum.vue';
import CountryPage from '../../components/country-page/country-page.vue';
import Breadcrumb from '../../components/breadcrumb/breadcrumb.vue';
import Heritage from '../../components/heritage/heritage.vue';
import ProductListing from '../../components/product-listing/product-listing.vue';
import ProductListingDropdown from '../../components/product-listing-dropdown/product-listing-dropdown.vue';
import ourIngredients from '../../components/our-ingredients/our-ingredients.vue';
import bazaarVoiceContent from '../../components/bazaar-voice-content/bazaar-voice-content.vue';
import Collapsible from '../../vendors/collapsible.js';
import CollapsibleNav from '../../vendors/collapsible-nav.js';
import BuyOnline from '../../vendors/buy-online.js';
import freeSampleForm from '../../vendors/free-sample-form.js';
import newsLetterForm from '../../vendors/news-letter-form.js';
import FormCheckboxValidation from '../../vendors/form-checkbox-validation.js';
import profilepageForm from '../../vendors/profile-page-form.js';
import dataprivacyAnchor from '../../vendors/dataprivacy-anchor.js';
import bazaarvoiceReview from '../../components/bazaarvoice-review/bazaarvoice-review.vue';
import videoPlaceholder from '../../components/video-placeholder/video-placeholder.vue';
import mixaOnloadTagging from '../../components/tagging/tagging.vue';
import ProductDetailsShort from '../../components/product-details-short/product-details-short.vue';
import ProductDetailsData from '../../components/product-details-short/product-details-data.vue';
import ProductLoop from '../../components/product-details-short/product-loop.vue';
import CommerceConnectCtaModal from '../../components/commerce-connect-cta-pane/commerce-connect-cta-modal.vue';
import Background from '../../feature/background/background.vue';
import Basket from '../../feature/basket/basket.vue';
import AddToCart from '../../feature/add-to-cart/add-to-cart.vue';
import strategy from '../../feature/events/global-strategy.js';
import busEvent from '../../feature/events/global-mediator.js';
import CookieBanner from '../../feature/cookie-banner/cookie-banner.vue';
import tag from '../../feature/tagging/tag-plugin.js';

import {
  stickyNav,
  onfocusAddClass,
  onfocusTriggerClick,
  owlCarousel,
  load,
  lazyloadScript,
} from '../../directives/index.js';
import loadUIModules from '../../utilities/load-ui-modules.js';

window.jQuery = jQuery;
window.$ = $;

new Collapsible();
new CollapsibleNav();
new BuyOnline();
new freeSampleForm();
new newsLetterForm();
new FormCheckboxValidation();
new profilepageForm();
new dataprivacyAnchor();

Vue.use(CarouselInstaller);
Vue.use(VueScrollTo);
Vue.use(VueShave);
Vue.use(VuePaginate);
Vue.use(VueYoutube);
Vue.use(highlight, {
  name: 'highlight',
  className: 'highlighttxt',
  style: 'font-weight:bold',
  caseSensitive: false,
});
Vue.use(checkView);
Vue.use(strategy);
Vue.use(busEvent);
Vue.use(tag);

// Redesign Vue component Declaration.
Vue.component(
  'bazaarvoice-main',
  () => import('../../components/bazaarvoice-main/bazaarvoice-main.vue'),
);
Vue.component(
  'ingredient-detail',
  () => import('../../components/ingredient-detail/ingredient-detail.vue'),
);
Vue.component(Banner.name, Banner);
Vue.component(Product.name, Product);
Vue.component(Tab.name, Tab);
Vue.component(carouselHome.name, carouselHome);
Vue.component(ClinicalTest.name, ClinicalTest);
Vue.component(ProductDetail.name, ProductDetail);
Vue.component(RatingsAndReviews.name, RatingsAndReviews);
Vue.component(BlocMixaMag.name, BlocMixaMag);
Vue.component(MixaMagCategory.name, MixaMagCategory);
Vue.component(MixaMagLatestArticle.name, MixaMagLatestArticle);
Vue.component(PopularItems.name, PopularItems);
Vue.component(ProductShortDetails.name, ProductShortDetails);
Vue.component(ArticleDetailPage.name, ArticleDetailPage);
Vue.component(homepageblock.name, homepageblock);
Vue.component(homepageblockright.name, homepageblockright);
Vue.component(Breadcrumb.name, Breadcrumb);
Vue.component(ProductListing.name, ProductListing);
Vue.component(ProductListingDropdown.name, ProductListingDropdown);
Vue.component(Commitments.name, Commitments);
Vue.component(Heritage.name, Heritage);
Vue.component(ourIngredients.name, ourIngredients);
Vue.component(bazaarVoiceContent.name, bazaarVoiceContent);
Vue.component(bazaarvoiceReview.name, bazaarvoiceReview);
Vue.component(Faq.name, Faq);
Vue.component(Impressum.name, Impressum);
Vue.component(CountryPage.name, CountryPage);
Vue.component(videoPlaceholder.name, videoPlaceholder);
Vue.component(mixaOnloadTagging.name, mixaOnloadTagging);
Vue.component(ProductDetailsShort.name, ProductDetailsShort);
Vue.component(ProductDetailsData.name, ProductDetailsData);
Vue.component(ProductLoop.name, ProductLoop);
Vue.component(CommerceConnectCtaModal.name, CommerceConnectCtaModal);
Vue.component(Background.name, Background);
Vue.component(Basket.name, Basket);
Vue.component(AddToCart.name, AddToCart);
Vue.component(CookieBanner.name, CookieBanner);

await loadUIModules(
  ['@refapp/ui-store-locator', '@refapp/ui-banner', '@refapp/ui-before-after'],
  Vue,
);
window.eventBus = new Vue();

const App = new Vue({
  directives: {
    onfocusAddClass,
    onfocusTriggerClick,
    stickyNav,
    owlCarousel,
    load,
    lazyloadScript,
  },
});

SitecoreVueBridge.initializeVueApp(App.$mount.bind(App, '#main-container'));
